import type React from "react"

/**
 * Shared visual language for the 88px rail's icon controls (nav items and
 * the bottom cluster: bell / theme / avatar / sign-out) so every control
 * hovers, focuses, and labels itself the same way.
 */

export const RailTooltip: React.FC<{ label: string }> = ({ label }) => (
	<span
		role="tooltip"
		className="pointer-events-none absolute left-full top-1/2 z-50 ml-2 -translate-y-1/2 whitespace-nowrap rounded-md border border-border bg-popover px-2 py-1 text-xs text-popover-foreground opacity-0 shadow-sm transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100"
	>
		{label}
	</span>
)

/**
 * Full-width rail row that anchors the tooltip and the hover group.
 * `shrink-0` keeps the 48px height on a short viewport: without it the rows
 * silently compress toward their ~40px min-content instead of letting the
 * scrolling <nav> take the overflow (sidebar.tsx).
 */
export const RAIL_CONTROL_CLASS =
	"group relative flex h-12 w-full shrink-0 items-center justify-center outline-none cursor-pointer"

/**
 * The same row in the 264px expanded menu: left-aligned with room for the
 * visible label next to the icon tile. Single source for every expanded rail
 * row (nav items, the toggle, and the footer's bell / theme / avatar /
 * sign-out) so they cannot drift apart.
 */
export const RAIL_ROW_EXPANDED_CLASS =
	"group relative flex h-12 w-full shrink-0 items-center justify-start gap-3 px-5 outline-none cursor-pointer"

/** The 40px icon tile inside a rail row. */
export const RAIL_CONTROL_ICON_CLASS =
	"flex h-10 w-10 items-center justify-center rounded-lg text-muted-foreground transition-colors group-hover:bg-accent/60 group-hover:text-foreground group-focus-visible:ring-2 group-focus-visible:ring-ring/60"
